/**
 * 각 노드 중앙을 기준으로 이웃 노드 계산 시 호출
 * Used to determine the coordinate that will be used to filter items that are over the "center"
 * @param isVertical
 * @param layout
 */
var getCutoffCoordinateFromCenter = function (isVertical, layout) {
    var _a = layout || {}, _b = _a.left, left = _b === void 0 ? 0 : _b, _c = _a.top, top = _c === void 0 ? 0 : _c, _d = _a.width, width = _d === void 0 ? 0 : _d, _e = _a.height, height = _e === void 0 ? 0 : _e;
    return isVertical ? top + Math.floor(height / 2) : left + Math.floor(width / 2);
};
export default getCutoffCoordinateFromCenter;
